import Link from "next/link";
import Multimedia from "@sharedComponents/multimedia";
import NoImage from "@assets/images/no-image.svg";

import { replaceCloudinaryDimensions } from "@helpers/menu";

import styles from "./category.module.scss";

const CategoryCard = (props) => {
  const { id, image, name, slug, className = styles.colCard } = props;
  return (
    <Link href={slug} passHref legacyBehavior prefetch={false}>
      <div className={`${styles.gutterSpace} ${className}`} key={id}>
        <a href={slug}>
          <div className={styles.slideItem}>
            <Multimedia
              type="image"
              src={
                replaceCloudinaryDimensions({
                  url: image,
                  height: 150,
                  width: 150,
                }) || NoImage
              }
              alt={name}
              height={160}
              width={192}
              className={`${styles.cardTileImg} ${image ? styles.withImage : styles.noImage}`}
            />
          </div>
          <div className={styles.name}>{name}</div>
        </a>
      </div>
    </Link>
  );
};

export default CategoryCard;
